// Module
var code = `<template>
  <require from="./nav-details-widget.scss"></require>
  <global-progress if.bind="loading"></global-progress>

  <div if.bind="!loading && !error" class="nav-details-widget nav-details-widget-\${id}">

    <!-- beautify ignore:start -->
    <style>
      .nav-details-widget-\${id} table {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <table>
      <thead>
        <tr>
          <th class="nav-details-widget__text"></th>
          <th if.bind="showAccountCode" class="nav-details-widget__number">Konto</th>
          <th if.bind="showGroupName"></th>
          <th if.bind="showEndOfLastYear" class="nav-details-widget__number">\${endOfLastYearLabel}</th>
          <th class="nav-details-widget__number">\${dateLabel}</th>
        </tr>
      </thead>
      <tbody>
        <tr repeat.for="row of rows" class="\${row.isGroup ? 'nav-details-widget__group' : ''} \${row.isAdjustment ? 'nav-details-widget__adjustment' : ''} \${row.isTotal ? 'nav-details-widget__total' : ''} \${row.isGrandTotal ? 'nav-details-widget__grand-total' : ''}">
          <td class="nav-details-widget__text">\${row.text}</td>
          <td if.bind="showAccountCode" class="nav-details-widget__number">\${row.accountCode}</td>
          <td if.bind="showGroupName">\${row.groupName}</td>
          <td if.bind="showEndOfLastYear" class="nav-details-widget__number">
            \${row.balanceEndOfLastYear | numericFormatter:'0,0'}</td>
          <td class="nav-details-widget__number">\${row.balance | numericFormatter:'0,0'}
            <promise-resolver resolve.bind="lastItemRendered" if.bind="\$last"></promise-resolver>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <message if.bind="error" icon="error" colour="mdc-theme--error" class="nav-details-widget__error">
    \${error.message}</message>
</template>
`;
// Exports
export default code;